import "@mui/material/styles/styled";
import * as Sentry from "@sentry/react";
import { lazy } from "react";
import ReactDOM from "react-dom/client";
import "./utils/sentry";

import { CssBaseline, ThemeProvider } from "@mui/material";
import Loadable from "./layouts/full/shared/loadable/Loadable";
import { StoreWrapper } from "./store/Store";
import { ThemeSettings } from "./theme/Theme";

const App = Loadable(lazy(() => import("./App")));

function ContentWithStore() {
  const theme = ThemeSettings();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}

// biome-ignore lint/style/noNonNullAssertion: needed
ReactDOM.createRoot(document.getElementById("root")!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StoreWrapper>
    <ContentWithStore />
  </StoreWrapper>,
);
